// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.missingreceipts', {
        url:'/missingreceipts',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/missingreceipts/missingreceipts.tpl.html',
            controller: 'SupportCaseMissingReceiptsController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseMissingReceiptsController($state, $scope, SupportApiService, UsersApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.selectedStartDate = {};
    vm.selectedEndDate = {};
    vm.selectedLocations = [];
    vm.locations = [];
    vm.missingEasyPosReceipts = [];
    vm.showSequenceNumbers = false;

    //Methods
    vm.search = search;

    activate();

    function activate() {
        UsersApiService.getLocations().then(function(locations) {
            vm.locations = locations;
        });
    }
    function search() {
        loadSpinnerService.start("mainSpinner");
        var request = {
            startDate: vm.selectedStartDate,
            endDate: vm.selectedEndDate,
            locationIds: []
        };
        _.forEach(vm.selectedLocations, function(o) {
            request.locationIds.push(o.id);
        });
        SupportApiService.getMissingEasyPosReceipts(request).then(function(response) {
            //ToasterService.showSuccess($translate.instant('support.barcodeChanged'), $translate.instant('support.supportCase'));
            vm.missingEasyPosReceipts = response.data;
            vm.missingEasyPosSequenceNumbers = [];
            _.forEach(response.data.missingReceiptSpans, function(mrs) {
                _.forEach(mrs.missingReceipts, function(mr) {
                    vm.missingEasyPosSequenceNumbers.push(mr.sequenceNumber);
                });
            });
        }, function(error) {
            var message = error.message + '\n';
            _.forEach(error.errors, function(err) {
                message += err.message + '\n';
            });
            ToasterService.showError(message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }
}

angular
    .module('supportcases.missingreceipts', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseMissingReceiptsController', SupportCaseMissingReceiptsController);
